import { FIELD_TYPES } from '../dynamic-form';
import { format } from 'date-fns';

export const CHECKER_FIELDS: { [key: string]: any } = {
  'Bulk Upload': [
    {
      id: 1,
      order: 1,
      key: 'TransactionNarration',
      field_type: FIELD_TYPES.PARAGRAPH,
      label: 'FIELDS.TRANSACTION_NARRATION',
      value: '',
      required: true,
    },
  ],
  'Cash request cancellation 299': [
    {
      id: 1,
      order: 1,
      key: 'RecieverBIC',
      field_type: FIELD_TYPES.BIC_AUTOCOMPLETE_FIELD,
      label: 'FIELDS.RECEIVER_BANK',
      value: '',
      readonly: true,
      required: true,
    },
    {
      id: 2,
      order: 2,
      key: 'Original299RefNumber',
      field_type: FIELD_TYPES.LINE,
      label: 'FIELDS.ORIGINAL_299_REFERENCE_NUMBER',
      value: '',
      required: true,
    },
    {
      id: 3,
      order: 3,
      key: 'TransferType',
      field_type: FIELD_TYPES.HIDDEN,
      label: 'FIELDS.TRANSFER_TYPE',
      value: '',
      required: true,
    },
    {
      id: 4,
      order: 4,
      key: 'TransactionType',
      field_type: FIELD_TYPES.HIDDEN,
      label: 'FIELDS.TRANSACTION_TYPE',
      value: '',
      required: true,
    },
    {
      id: 5,
      order: 5,
      key: 'CenterNumber',
      field_type: FIELD_TYPES.HIDDEN,
      label: 'FIELDS.CENTER_NUMBER',
      value: '',
      required: true,
    },
    {
      id: 6,
      order: 6,
      key: 'CountryCode',
      field_type: FIELD_TYPES.HIDDEN,
      label: 'FIELDS.COUNTRY_CODE',
      value: '',
      required: false,
    },
  ],
  'Fund transfer 103': [],
  CorrespondentQuery: [
    {
      id: 1,
      order: 1,
      key: 'MT103ReferenceNumber',
      field_type: FIELD_TYPES.LINE,
      label: 'FIELDS.MT103_REF_NUMBER',
      value: '',
      required: true,
    },
    {
      id: 2,
      order: 2,
      key: 'RelatedRefNumber',
      field_type: FIELD_TYPES.LINE,
      label: 'FIELDS.RELATED_REF_NUMBER',
      value: '',
      required: true,
    },
    {
      id: 3,
      order: 3,
      key: 'Reason',
      field_type: FIELD_TYPES.SELECT,
      label: 'FIELDS.REASON',
      options: [
        { label: 'Account Number', value: 'AccountNumber' },
        { label: 'Account Name', value: 'AccountName' },
        {
          label: 'Account Number / Account Name',
          value: 'AccountNumber/AccountName',
        },
      ],
      value: '',
      placeholder: '',
      required: true,
    },
    {
      id: 4,
      order: 4,
      key: 'NewValue',
      field_type: FIELD_TYPES.LINE,
      label: 'FIELDS.NEW_VALUE',
      value: '',
      required: true,
    },
    {
      id: 5,
      order: 5,
      key: 'RecieverBIC',
      field_type: FIELD_TYPES.BIC_AUTOCOMPLETE_FIELD,
      label: 'FIELDS.RECEIVER_BIC',
      value: '',
      readonly: true,
      required: true,
    },
    {
      id: 7,
      order: 7,
      key: 'RecallCancelationType',
      field_type: FIELD_TYPES.HIDDEN,
      label: 'FIELDS.RECALL_CANCELLATION_TYPE',
      value: '',
      required: true,
    },
  ],
  ProvisonOfDetails: [
    {
      id: 1,
      order: 1,
      key: 'MT103ReferenceNumber',
      field_type: FIELD_TYPES.LINE,
      label: 'FIELDS.MT103_REF_NUMBER',
      value: '',
      required: true,
    },
    {
      id: 2,
      order: 2,
      key: 'RelatedRefNumber',
      field_type: FIELD_TYPES.LINE,
      label: 'FIELDS.RELATED_REF_NUMBER',
      value: '',
      required: true,
    },
    {
      id: 3,
      order: 3,
      key: 'RecieverBIC',
      field_type: FIELD_TYPES.BIC_AUTOCOMPLETE_FIELD,
      label: 'FIELDS.RECEIVER_BIC',
      value: '',
      readonly: true,
      required: true,
    },
    {
      id: 5,
      order: 5,
      key: 'RecallCancelationType',
      field_type: FIELD_TYPES.HIDDEN,
      label: 'FIELDS.RECALL_CANCELLATION_TYPE',
      value: '',
      required: true,
    },
    {
      id: 6,
      order: 6,
      key: 'Field79',
      field_type: FIELD_TYPES.PARAGRAPH,
      label: 'FIELDS.FIELD_79',
      value: '',
      rows: 10,
      required: true,
      styleClass: 'field-100',
    },
  ],
  ConfirmationOfMT103: [
    {
      id: 1,
      order: 1,
      key: 'MT103ReferenceNumber',
      field_type: FIELD_TYPES.LINE,
      label: 'FIELDS.MT103_REF_NUMBER',
      value: '',
      required: true,
    },
    {
      id: 2,
      order: 2,
      key: 'RelatedRefNumber',
      field_type: FIELD_TYPES.LINE,
      label: 'FIELDS.RELATED_REF_NUMBER',
      value: '',
      required: true,
    },
    {
      id: 4,
      order: 4,
      key: 'RecieverBIC',
      field_type: FIELD_TYPES.BIC_AUTOCOMPLETE_FIELD,
      label: 'FIELDS.RECEIVER_BIC',
      value: '',
      readonly: true,
      required: true,
    },
    {
      id: 6,
      order: 6,
      key: 'RecallCancelationType',
      field_type: FIELD_TYPES.HIDDEN,
      label: 'FIELDS.RECALL_CANCELLATION_TYPE',
      value: '',
      required: true,
    },
  ],
  Recall: [
    {
      id: 1,
      order: 1,
      key: 'MT103ReferenceNumber',
      field_type: FIELD_TYPES.LINE,
      label: 'FIELDS.MT103_REF_NUMBER',
      value: '',
      required: true,
    },
    {
      id: 2,
      order: 2,
      key: 'RelatedRefNumber',
      field_type: FIELD_TYPES.LINE,
      label: 'FIELDS.RELATED_REF_NUMBER',
      value: '',
      required: true,
    },
    {
      id: 3,
      order: 3,
      key: 'OriginalMessageDate',
      field_type: FIELD_TYPES.DATETIME,
      label: 'FIELDS.ORIGINAL_MESSAGE_DATE',
      value: '',
      minimum: new Date('1950-01-01'),
      required: true,
    },
    {
      id: 4,
      order: 4,
      key: 'RecieverBIC',
      field_type: FIELD_TYPES.BIC_AUTOCOMPLETE_FIELD,
      label: 'FIELDS.RECEIVER_BIC',
      value: '',
      readonly: true,
      required: true,
    },
    {
      id: 6,
      order: 6,
      key: 'RequestType',
      field_type: FIELD_TYPES.HIDDEN,
      label: 'FIELDS.REQUEST_TYPE',
      value: '',
      required: true,
    },
  ],
  'Cash request 202': [
    {
      id: 1,
      order: 1,
      key: 'ReceiverBIC',
      field_type: FIELD_TYPES.BIC_AUTOCOMPLETE_FIELD,
      label: 'FIELDS.RECEIVER_BIC',
      value: '',
      placeholder: '',
      readonly: true,
      required: true,
    },
    {
      id: 2,
      order: 2,
      key: 'ValueDate',
      field_type: FIELD_TYPES.DATETIME,
      label: 'FIELDS.VALUE_DATE',
      value: '',
      minimum: new Date('1950-01-01'),
      placeholder: '',
      required: true,
    },
    {
      id: 3,
      order: 3,
      key: 'Amount',
      field_type: FIELD_TYPES.LINE_AMOUNT_FIELD,
      label: 'FIELDS.AMOUNT',
      value: '',
      placeholder: '',
      required: true,
    },
    {
      id: 4,
      order: 4,
      key: 'Currency',
      field_type: FIELD_TYPES.SELECT,
      label: 'FIELDS.REMITTANCE_CURRENCY',
      options: [
        { label: 'USD', value: 'USD' },
        { label: 'EUR', value: 'EUR' },
      ],
      value: '',
      placeholder: '',
      required: true,
    },
    {
      id: 5,
      order: 5,
      key: 'RelatedRefNumber',
      field_type: FIELD_TYPES.LINE,
      label: 'FIELDS.RELATED_REFERENCE_NUMBER',
      value: '',
      placeholder: '',
      required: true,
    },
  ],
  'Cash request 299': [
    {
      id: 1,
      order: 1,
      key: 'RecieverBIC',
      field_type: FIELD_TYPES.BIC_AUTOCOMPLETE_FIELD,
      label: 'FIELDS.RECEIVER_BIC',
      options$: null,
      value: '',
      required: true,
      readonly: true,
    },
    {
      id: 2,
      order: 2,
      key: 'CenterNumber',
      field_type: FIELD_TYPES.LINE,
      label: 'FIELDS.CENTER_NUMBER',
      value: '',
      readonly: true,
      required: true,
    },
    {
      id: 3,
      order: 3,
      key: 'CenterName',
      field_type: FIELD_TYPES.LINE,
      label: 'FIELDS.CENTER_NAME',
      value: '',
      readonly: true,
      required: true,
    },
    {
      id: 4,
      order: 4,
      key: 'TransactionDate',
      field_type: FIELD_TYPES.DATETIME,
      label: 'FIELDS.TRANSACTION_DATE',
      value: format(new Date(), 'yyyy/MM/dd'),
      minimum: new Date('1950-01-01'),
      required: true,
    },
    {
      id: 5,
      order: 5,
      key: 'ValueDate',
      field_type: FIELD_TYPES.DATETIME,
      label: 'FIELDS.VALUE_DATE',
      value: '',
      minimum: new Date('1950-01-01'),
      required: true,
    },
    {
      id: 6,
      order: 6,
      key: 'TransferType',
      field_type: FIELD_TYPES.HIDDEN,
      label: 'FIELDS.TRANSFER_TYPE',
      value: '',
      required: true,
    },
    {
      id: 7,
      order: 7,
      key: 'TransactionType',
      field_type: FIELD_TYPES.HIDDEN,
      label: 'FIELDS.TRANSACTION_TYPE',
      value: '',
      required: true,
    },
    {
      id: 8,
      order: 8,
      key: 'CountryCode',
      field_type: FIELD_TYPES.HIDDEN,
      label: 'FIELDS.COUNTRY_CODE',
      value: '',
      required: true,
    },
    {
      id: 9,
      order: 9,
      key: 'Currency',
      field_type: FIELD_TYPES.HIDDEN,
      label: 'FIELDS.CURRENCY',
      value: '',
      required: true,
    },
    {
      id: 10,
      order: 10,
      key: 'TransactionReference',
      field_type: FIELD_TYPES.HIDDEN,
      label: 'FIELDS.TRANSACTION_REFERENCE',
      value: '',
      required: false,
    },
  ],
  'Normal MT299': [
    {
      id: 1,
      order: 1,
      key: 'RelatedRefNumber',
      field_type: FIELD_TYPES.LINE,
      label: 'FIELDS.RELATED_REF_NUMBER',
      value: '',
      required: true,
    },
    {
      id: 2,
      order: 2,
      key: 'RecieverBIC',
      field_type: FIELD_TYPES.BIC_AUTOCOMPLETE_FIELD,
      label: 'FIELDS.RECEIVER_BIC',
      value: '',
      required: true,
    },
    {
      id: 3,
      order: 3,
      key: 'TransferType',
      field_type: FIELD_TYPES.HIDDEN,
      label: 'FIELDS.TRANSFER_TYPE',
      value: '',
      required: true,
    },
    {
      id: 4,
      order: 4,
      key: 'CountryCode',
      field_type: FIELD_TYPES.HIDDEN,
      label: 'FIELDS.COUNTRY_CODE',
      value: '',
      required: false,
    },
    {
      id: 5,
      order: 5,
      key: 'CenterNumber',
      field_type: FIELD_TYPES.HIDDEN,
      label: 'FIELDS.CENTER_NUMBER',
      value: '',
      required: false,
    },
    {
      id: 6,
      order: 6,
      key: 'Field79',
      field_type: FIELD_TYPES.PARAGRAPH,
      label: 'FIELDS.FIELD_79',
      value: '',
      rows: 10,
      required: true,
      styleClass: 'field-100',
    },
  ],
  Statement: [
    {
      id: 1,
      order: 1,
      key: 'AccountNumber',
      field_type: FIELD_TYPES.LINE,
      label: 'FIELDS.ACCOUNT_NUMBER',
      value: '',
      required: true,
    },
    {
      id: 2,
      order: 2,
      key: 'StatementType',
      field_type: FIELD_TYPES.SELECT,
      label: 'FIELDS.STATEMENT_TYPE',
      options: [
        { label: 'MT 940', value: '940' },
        { label: 'MT 950', value: '950' },
      ],
      value: '',
      required: true,
    },
    {
      id: 3,
      order: 3,
      key: 'RecieverBIC',
      field_type: FIELD_TYPES.BIC_AUTOCOMPLETE_FIELD,
      label: 'FIELDS.RECEIVER_BIC',
      value: '',
      readonly: true,
      required: true,
    },
    {
      id: 4,
      order: 4,
      key: 'Frequency',
      field_type: FIELD_TYPES.SELECT,
      options: [
        { label: 'One Time', value: '' },
        { label: 'Daily', value: 'Daily' },
        { label: 'Weekly', value: 'Weekly' },
        { label: 'Monthly', value: 'Monthly' },
        { label: 'Yearly', value: 'Yearly' },
      ],
      label: 'FIELDS.FREQUENCY',
      value: '',
      required: false,
    },
    {
      id: 5,
      order: 5,
      key: 'StartDate',
      field_type: FIELD_TYPES.DATETIME,
      label: 'FIELDS.START_DATE',
      value: '',
      maximum: format(new Date(), "yyyy-MM-dd'T'HH:mm:ssXXX"),
      minimum: new Date('1950-01-01'),
      required: true,
    },
    {
      id: 6,
      order: 6,
      key: 'EndDate',
      field_type: FIELD_TYPES.DATETIME,
      label: 'FIELDS.END_DATE',
      value: '',
      minimum: new Date('1950-01-01'),
      required: true,
    },
  ],
};
